import { useEffect, useState } from "react";
import { getCodeList } from "../services/CodexAPI";

// B22: Placing Explanation Reason for Response
export const REASON_CODELIST = "B22";

// Loaded once per session and shared by every dropdown and label
let pending = null;
const loadReasons = () => {
  if (!pending) {
    pending = getCodeList(REASON_CODELIST)
      .then((list) =>
        (Array.isArray(list?.codes) ? list.codes : [])
          .map((c) => ({ code: c.longCode, description: c.description1 || c.longCode }))
          .filter((r) => r.code)
          .sort((a, b) => a.description.localeCompare(b.description))
      )
      .catch((err) => {
        pending = null; // try again next time
        throw err;
      });
  }
  return pending;
};

/**
 * B22 reason codes from Codex: { reasons: [{ code, description }], loading,
 * error, describe(code), isOther(code) }. Codes are sent as the long code.
 */
export const useReasonCodes = () => {
  const [state, setState] = useState({ reasons: [], loading: true, error: null });

  useEffect(() => {
    let cancelled = false;
    loadReasons()
      .then((reasons) => !cancelled && setState({ reasons, loading: false, error: null }))
      .catch((error) => !cancelled && setState({ reasons: [], loading: false, error }));
    return () => {
      cancelled = true;
    };
  }, []);

  const describe = (code) => state.reasons.find((r) => r.code === code)?.description || code || "";
  // "Other" needs explaining in the text box
  const isOther = (code) => !!code && (/other/i.test(code) || /^other\b/i.test(describe(code)));

  return { ...state, describe, isOther };
};
